import { Box } from '@wegroup/design-system';
import React from 'react';
import SelectedOffersContainer from '../../../components/selected-offers/SelectedOffersContainer';

const SelectedOffers: React.FC = () => {
  return (
    <Box
      overflowY={{ base: 'unset', laptop: 'auto' }}
      h={{ base: 'unset', laptop: '100%' }}
    >
      <SelectedOffersContainer />
    </Box>
  );
};

export default SelectedOffers;
